<template><div><h1 id="wahrung-umrechnungskurse" tabindex="-1"><a class="header-anchor" href="#wahrung-umrechnungskurse"><span>Währung Umrechnungskurse</span></a></h1>
<p>Währungs-Position — Definiert Währungs-Positionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die Währungs-Positionen im System sowie die aktuell gültigen Wechselkurse. Pro Währung können beliebig viele Wechselkurse mit einem Gültigkeitsdatum versehen hinterlegt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Währungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Währung</dt>
<dd>Kürzel der Währung, wird vom System automatisch vorgeschlagen</dd>
<dt>gültig bis</dt>
<dd>Gültigkeitsdatum, bis wann der Wechselkurs für Berechnungen verwendet werden soll</dd>
<dt>Kurs</dt>
<dd>Wechselkurs, 6stellig, numerisch, mit max. 4 Dezimalstellen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.whg.html" title="Währung">Währung</RouteLink></p>
</div></template>


